import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TRACK_NAV } from "./trackNav";
import TrackOrganizations from "./TrackOrganizations";
import TrackCoaches from "./TrackCoaches";
import TrackModule from "./TrackModule";

const GLOBAL = new Set(["organizations", "coaches"]);

export default function TrackAdmin() {
  const [sub, setSub] = useState("organizations");
  const [orgs, setOrgs] = useState([]);
  const [orgId, setOrgId] = useState("");

  useEffect(() => {
    api.get("/track/organizations").then(({ data }) => {
      setOrgs(data);
      setOrgId((cur) => cur || (data[0]?.id || ""));
    }).catch(() => {});
  }, []);

  const isGlobal = GLOBAL.has(sub);
  return (
    <div data-testid="track-admin">
      <div className="mb-6 flex items-start justify-between flex-wrap gap-4">
        <div>
          <p className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40 mb-1">Super Admin Command Center</p>
          <p className="font-display font-black uppercase tracking-tighter text-2xl">Origin Track OS</p>
        </div>
        {!isGlobal && (
          <div>
            <label className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-white/40 block mb-1.5">Active Organization</label>
            <select data-testid="track-org-selector" value={orgId} onChange={(e) => setOrgId(e.target.value)} className="bg-[#0A0A0A] border border-white/15 focus:border-white outline-none px-3 py-2.5 text-sm min-w-[220px]">
              <option value="">— Select —</option>
              {orgs.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
            </select>
          </div>
        )}
      </div>

      <div className="flex gap-1 border-b border-white/10 mb-8 overflow-x-auto" data-testid="track-subnav">
        {TRACK_NAV.map((n) => {
          const Icon = n.icon;
          return (
            <button key={n.key} data-testid={`track-tab-${n.key}`} onClick={() => setSub(n.key)}
              className={`flex items-center gap-2 px-4 py-3 text-xs uppercase tracking-widest font-bold whitespace-nowrap border-b-2 transition-colors ${sub === n.key ? "border-white text-white" : "border-transparent text-white/40 hover:text-white"}`}>
              <Icon size={14} /> {n.label}
            </button>
          );
        })}
      </div>

      {sub === "organizations" ? <TrackOrganizations />
        : sub === "coaches" ? <TrackCoaches />
        : <TrackModule section={sub} orgId={orgId} canWrite={true} />}
    </div>
  );
}
